import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccountingModal } from "../../../../components/modals/accountingModal";
import {
  setReportLimit,
  setReportPage,
  setShowAccountingModal,
} from "../../../../redux/actions/reports/reportsAction";
import { getReports } from "../../../../redux/actions/api/apiAction";

export const ActionDetailsButton = ({ category }) => {
  const { showAccountingDetails,reportQuery } = useSelector((state) => state.report);
  const dispatch = useDispatch();
  return (
    <div className="c-pointer">
      {showAccountingDetails[category] && (
        <AccountingModal
          toggle={() => {
            dispatch(setShowAccountingModal({ [category]: false }));
          }}
          category={category}
        />
      )}
    </div>
  );
};
